import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import {
  addSpaceEvery4,
  formatDate,
  getDayNameIndo,
} from "../../../constants/helper";
import { tempUrl } from "../../../contexts/ContextProvider";
import { useStateContext } from "../../../contexts/ContextProvider";
import { AuthContext } from "../../../contexts/AuthContext";
import { ShowTableSuratSomasi } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import {
  SearchBar,
  Loader,
  ButtonModifier,
  ScrollToTop,
} from "../../../components";
import {
  Box,
  TextField,
  Typography,
  Divider,
  Pagination,
  ButtonGroup,
  Button,
  Autocomplete,
} from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import PrintIcon from "@mui/icons-material/Print";
import { Col, Row, Form } from "react-bootstrap";
import angkaTerbilang from "@develoka/angka-terbilang-js";

const TampilSuratSomasi = () => {
  const { setting, user } = useContext(AuthContext);
  const { dispatch } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const { screenSize } = useStateContext();
  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };
  const [isFetchError, setIsFetchError] = useState(false);
  const [isSuratSomasisExist, setIsSuratSomasisExist] = useState(false);
  const [noSuratSomasi, setNoSuratSomasi] = useState("");
  const [tglSuratSomasi, setTglSuratSomasi] = useState("");
  const [tglSuratSomasiDate, setTglSuratSomasiDate] = useState("");
  const [tglSuratSomasiAkhirDate, setTglSuratSomasiAkhirDate] = useState("");
  const [noJual, setNoJual] = useState("");
  const [suratSomasiKe, setSuratSomasiKe] = useState("");
  const [tlpRegister, setTlpRegister] = useState("");
  const [jumlahPiutang, setJumlahPiutang] = useState("");
  const [jumlahBayar, setJumlahBayar] = useState("");
  const [tanggalJual, setTanggalJual] = useState("");
  const [namaKolektor, setNamaKolektor] = useState("");
  const [kodeKolektor, setKodeKolektor] = useState("");
  const [namaRegister, setNamaRegister] = useState("");
  const [tahun, setTahun] = useState("");
  const [isi, setIsi] = useState("");
  const [namaWarna, setNamaWarna] = useState("");
  const [noRangka, setNoRangka] = useState("");
  const [noMesin, setNoMesin] = useState("");

  // Delete it
  const [almRegister, setAlmRegister] = useState("");
  const [nopol, setNopol] = useState("");
  const [merk, setMerk] = useState("");
  const [kodeTipe, setKodeTipe] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [suratSomasisData, setSuratSomasisData] = useState([]);
  const [kodeKolektorInput, setKodeKolektorInput] = useState("");
  const [kolektors, setKolektors] = useState([]);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  let findMonth = (monthNumber) => {
    if (monthNumber === 1) {
      return "JANUARI";
    } else if (monthNumber === 2) {
      return "FEBRUARI";
    } else if (monthNumber === 3) {
      return "MARET";
    } else if (monthNumber === 4) {
      return "APRIL";
    } else if (monthNumber === 5) {
      return "MEI";
    } else if (monthNumber === 6) {
      return "JUNI";
    } else if (monthNumber === 7) {
      return "JULI";
    } else if (monthNumber === 8) {
      return "AGUSTUS";
    } else if (monthNumber === 9) {
      return "SEPTEMBER";
    } else if (monthNumber === 10) {
      return "OKTOBER";
    } else if (monthNumber === 11) {
      return "NOVEMBER";
    } else if (monthNumber === 12) {
      return "DESEMBER";
    }
  };

  const kolektorOptions = kolektors.map((kolektor) => ({
    label: `${kolektor.kodeKolektor} - ${kolektor.namaKolektor}`,
  }));

  useEffect(() => {
    id ? getSuratSomasiById() : setIsSuratSomasisExist(false);
  }, [id]);

  useEffect(() => {
    if (user.tipeUser === "OWN/DIREKSI") {
      getSuratSomasiAllCabangsData();
    } else {
      getSuratSomasisData();
    }
    getKolektor();
  }, [page, searchTerm]);

  const getSuratSomasiAllCabangsData = async () => {
    setLoading(true);
    try {
      // Filter Kolektor/Eksekutor
      const pickedKolektor = await axios.post(`${tempUrl}/kolektorByKode`, {
        kodeKolektorInput,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });

      let tempKodeKolektor;
      if (pickedKolektor.data) {
        tempKodeKolektor = pickedKolektor.data._id;
      }

      if (user.tipeUser === "EKS") {
        tempKodeKolektor = user.kodeKolektor;
      }

      let allSuratSomasis = await axios.post(
        `${tempUrl}/suratSomasisPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          kodeKolektor: tempKodeKolektor,
          id: user._id,
          token: user.token,
        }
      );

      setQuery(searchTerm);
      setSuratSomasisData(allSuratSomasis.data.suratSomasis);
      setPage(allSuratSomasis.data.page);
      setPages(allSuratSomasis.data.totalPage);
      setRows(allSuratSomasis.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getSuratSomasisData = async () => {
    setLoading(true);
    try {
      // Filter Kolektor/Eksekutor
      const pickedKolektor = await axios.post(`${tempUrl}/kolektorByKode`, {
        kodeKolektorInput,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });

      let tempKodeKolektor;
      if (pickedKolektor.data) {
        tempKodeKolektor = pickedKolektor.data._id;
      }

      if (user.tipeUser === "EKS") {
        tempKodeKolektor = user.kodeKolektor;
      }

      let allSuratSomasis = await axios.post(
        `${tempUrl}/suratSomasisPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          kodeKolektor: tempKodeKolektor,
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        }
      );

      setQuery(searchTerm);
      setSuratSomasisData(allSuratSomasis.data.suratSomasis);
      setPage(allSuratSomasis.data.page);
      setPages(allSuratSomasis.data.totalPage);
      setRows(allSuratSomasis.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  function dhm(t) {
    var cd = 24 * 60 * 60 * 1000,
      ch = 60 * 60 * 1000,
      d = Math.floor(t / cd),
      h = Math.floor((t - d * cd) / ch),
      m = Math.round((t - d * cd - h * ch) / 60000),
      pad = function (n) {
        return n < 10 ? "0" + n : n;
      };
    if (m === 60) {
      h++;
      m = 0;
    }
    if (h === 24) {
      d++;
      h = 0;
    }
    return d;
  }

  const getKolektor = async () => {
    setLoading(true);
    const response = await axios.post(`${tempUrl}/kolektors`, {
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });
    setKolektors(response.data);
    setLoading(false);
  };

  const getSuratSomasiById = async () => {
    setLoading(true);
    if (id) {
      const response = await axios.post(`${tempUrl}/suratSomasis/${id}`, {
        id: user._id,
        token: user.token,
      });
      setIsSuratSomasisExist(true);
      setNoSuratSomasi(response.data.noSuratSomasi);
      setTglSuratSomasi(formatDate(response.data.tglSuratSomasi));
      setTglSuratSomasiDate(new Date(response.data.tglSuratSomasi));
      let tempTglSuratSomasi = new Date(response.data.tglSuratSomasi);
      tempTglSuratSomasi.setDate(
        tempTglSuratSomasi.getDate() + Number(user.cabang.lamaHariSomasi)
      );
      setTglSuratSomasiAkhirDate(tempTglSuratSomasi);
      setNoJual(response.data.noJual);
      setSuratSomasiKe(response.data.suratSomasiKe);
      setTlpRegister(response.data.tlpRegister);
      setJumlahPiutang(response.data.jumlahPiutang);
      setJumlahBayar(response.data.jumlahBayar);
      setNamaKolektor(response.data.kodeKolektor.namaKolektor);
      setKodeKolektor(
        `${response.data.kodeKolektor.kodeKolektor} - ${response.data.kodeKolektor.namaKolektor}`
      );
      setTanggalJual(response.data.idJual.tanggalJual);
      setNamaRegister(response.data.idJual.namaRegister);
      setTahun(response.data.idJual.tahun);
      setNamaWarna(response.data.idJual.namaWarna);
      setNoRangka(response.data.idJual.noRangka);
      setNoMesin(response.data.idJual.noMesin);

      setAlmRegister(response.data.idJual.almRegister);
      setNopol(response.data.idJual.nopol);

      const pickedTipe = await axios.post(`${tempUrl}/tipesByKode`, {
        kodeTipe: response.data.idJual.tipe,
        id: user._id,
        token: user.token,
      });

      setMerk(pickedTipe.data.merk);
      setIsi(pickedTipe.data.isi);
      setKodeTipe(response.data.idJual.tipe);
    }
    setLoading(false);
  };

  const filterKolektor = async (value) => {
    let kodeKolektor = value.split(" ", 1)[0];
    setKodeKolektorInput(kodeKolektor);

    if (value.length === 0) {
      getSuratSomasisData();
      getKolektor();
      setKodeKolektorInput("");
      return;
    }

    const pickedKolektor = await axios.post(`${tempUrl}/kolektorByKode`, {
      kodeKolektor,
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });

    let tempKodeKolektor;
    if (pickedKolektor.data) {
      tempKodeKolektor = pickedKolektor.data._id;
    }

    if (pickedKolektor.data) {
      let allSuratSomasis = await axios.post(
        `${tempUrl}/suratSomasisPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          kodeKolektor: tempKodeKolektor,
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        }
      );

      setKodeKolektorInput(kodeKolektor);
      setQuery(searchTerm);
      setSuratSomasisData(allSuratSomasis.data.suratSomasis);
      setPage(allSuratSomasis.data.page);
      setPages(allSuratSomasis.data.totalPage);
      setRows(allSuratSomasis.data.totalRows);
    }
  };

  const deleteSuratSomasi = async (id) => {
    try {
      setLoading(true);
      var date = new Date();
      var current_date =
        date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
      var current_time =
        date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();

      // Delete Surat Somasi Transaction
      await axios.post(`${tempUrl}/deleteSuratSomasi/${id}`, {
        id: user._id,
        token: user.token,
      });

      setNoSuratSomasi("");
      setTglSuratSomasi("");
      setNoJual("");
      setSuratSomasiKe("");
      setTlpRegister("");
      setJumlahPiutang("");
      setJumlahBayar("");
      setKodeKolektor("");
      setLoading(false);
      navigate("/suratSomasi");
      getSuratSomasisData();
    } catch (error) {
      console.log(error);
    }
  };

  const downloadPdf = async () => {
    let tempY = 30;
    let tempTglSuratSomasi = new Date(tglSuratSomasiDate);
    let tempNameMonthTglSuratSomasi = findMonth(
      tempTglSuratSomasi.getMonth() + 1
    );
    let tempTanggalJual = new Date(tanggalJual);
    let tempNameMonthTanggalJual = findMonth(tempTanggalJual.getMonth() + 1);

    const doc = new jsPDF();

    // Convert JPG file to Base64 Data URL
    const toDataURL = (url) =>
      fetch(url)
        .then((response) => response.blob())
        .then(
          (blob) =>
            new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.readAsDataURL(blob);
            })
        );

    // Load the JPG from public folder
    const imgData = await toDataURL("/LogoPerusahaan.jpg"); // make sure the image is in public/

    // Add image to PDF
    doc.addImage(imgData, "JPEG", 140, 10, 50, 20);

    doc.setFontSize(12);
    tempY += 6;
    doc.text(
      `JAKARTA, ${getDayNameIndo(tglSuratSomasiDate)} ${tglSuratSomasi}`,
      186,
      tempY,
      {
        align: "right",
      }
    );

    tempY += 6;
    doc.text(`No.`, 20, tempY);
    doc.text(`: ${noSuratSomasi}`, 40, tempY);
    tempY += 6;
    doc.text(`Lamp.`, 20, tempY);
    doc.text(`: Tabel Rincian Sisa Pembayaran`, 40, tempY);

    tempY += 10;
    doc.text(`Kepada Yang Terhormat`, 20, tempY);
    tempY += 6;
    doc.setFont(undefined, "bold");
    doc.text(`${namaRegister}`, 20, tempY);
    doc.setFont(undefined, "normal");
    tempY += 6;
    doc.text(`${almRegister.slice(0, 70)}`, 20, tempY);

    tempY += 15;
    doc.setFont(undefined, "bold");
    doc.text(`PERIHAL : SURAT PERINGATAN (SOMASI) ${suratSomasiKe}`, 65, tempY);
    doc.setFont(undefined, "normal");

    tempY += 10;
    doc.text(`Dengan Hormat,`, 20, tempY);
    tempY += 6;
    doc.text(
      `Merujuk kepada Perjanjian ${noJual} (“Perjanjian Sewa Beli”), tanggal ${formatDate(
        tanggalJual
      )}`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `Bersama ini Kami menyampaikan hal-hal sebagai berikut:`,
      20,
      tempY
    );

    tempY += 10;
    doc.text(`1.`, 10, tempY);
    doc.text(
      `Berdasarkan data-data dan informasi yang Kami miliki sampai dengan tanggal surat ini`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `${namaRegister} (“Penyewa”) masih memiliki kewajiban pembayaran`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(`yang sampai dengan saat ini berjumlah`, 20, tempY);
    doc.setFont(undefined, "bold");
    doc.text(`Rp. ${jumlahPiutang.toLocaleString("en-US")},-`, 100, tempY);
    tempY += 6;
    doc.text(`(${angkaTerbilang(jumlahPiutang)} rupiah ) `, 20, tempY);
    tempY += 6;
    doc.text(`("Sisa Kewajiban") .`, 20, tempY);
    doc.setFont(undefined, "normal");

    tempY += 10;
    doc.text(`2.`, 10, tempY);
    doc.text(
      `Atas Perjanjian Sewa Beli yang telah diterbitkan, pada dasarnya Penyewa wajib untuk`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `melakukan pembayaran sesuai dengan jangka waktu yang telah ditentukan. Namun,`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `sampai dengan diterbitkannya surat ini, Penyewa belum melakukan pembayaran`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `dan/atau menyelesaikan uang sewa yang telah jatuh tempo kepada Kami.`,
      20,
      tempY
    );

    tempY += 10;
    doc.text(`3.`, 10, tempY);
    doc.text(
      `Lebih lanjut, berdasarkan data dan dokumen Kami, Penyewa baru melakukan pembayaran`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(`sebesar`, 20, tempY);
    doc.setFont(undefined, "bold");
    doc.text(`Rp. ${jumlahBayar.toLocaleString("en-US")},-`, 40, tempY);
    doc.setFont(undefined, "normal");
    tempY += 6;
    doc.text(
      `Namun walaupun Penyewa telah melakukan pembayaran, Penyewa masih belum dan/atau`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `melakukan pembayaran atas sisa kewajiban pembayaran sebesar`,
      20,
      tempY
    );
    doc.setFont(undefined, "bold");
    doc.text(`Rp. ${jumlahPiutang.toLocaleString("en-US")},-`, 150, tempY);
    tempY += 6;
    doc.text(`(${angkaTerbilang(jumlahPiutang)} rupiah )`, 20, tempY);
    tempY += 6;
    doc.text(`("Sisa Kewajiban") .`, 20, tempY);
    doc.setFont(undefined, "normal");

    tempY += 10;
    doc.text(`4.`, 10, tempY);
    doc.text(`Perlu Kami tegaskan kembali kepada Penyewa bahwa:`, 20, tempY);

    doc.addPage();

    // Add image to PDF
    doc.addImage(imgData, "JPEG", 140, 10, 50, 20);

    tempY = 30;
    tempY += 6;
    doc.text(
      `Tindakan Penyewa yang secara sengaja tidak membayarkan Sisa Kewajiban kepada Klien`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `Kami, hal tersebut menunjukkan itikad buruk dan mengindikasikan dugaan tindak pidana`,
      20,
      tempY
    );
    tempY += 6;
    doc.setFont(undefined, "bold");
    doc.text(`PENGGELAPAN`, 20, tempY);
    doc.setFont(undefined, "normal");
    doc.text(`dan`, 55, tempY);
    doc.setFont(undefined, "bold");
    doc.text(`PENIPUAN`, 63, tempY);
    doc.setFont(undefined, "normal");
    doc.text(`yang diatur dalam ketentuan Pasal 372 dan 378 Kitab`, 87, tempY);
    tempY += 6;
    doc.text(
      `Undang-Undang Hukum Pidana (KUHP) yang secara tegas menyatakan sebagai berikut:`,
      20,
      tempY
    );

    tempY += 15;
    doc.setFont(undefined, "bold");
    doc.text(`Pasal 372 KUHP`, 20, tempY);
    tempY += 6;
    doc.text(
      `"Barang siapa dengan sengaja dan melawan hukum memiliki barang sesuatu yang`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `seluruhnya atau sebagian adalah kepunyaan orang lain, tetapi yang ada dalam`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(`kekuasaannya bukan karena kejahatan`, 20, tempY);
    let text = `DIANCAM KARENA PENGGELAPAN, DENGAN`;
    doc.text(text, 100, tempY);
    let textWidth = doc.getTextWidth(text);
    doc.line(
      100, // start X
      tempY + 1, // start Y (slightly below text)
      100 + textWidth, // end X (start X + text width)
      tempY + 1 // end Y (same as start Y to make it straight)
    );
    tempY += 6;
    text = `PIDANA PENJARA PALING LAMA EMPAT TAHUN.`;
    doc.text(text, 20, tempY);
    textWidth = doc.getTextWidth(text);
    doc.line(
      20, // start X
      tempY + 1, // start Y (slightly below text)
      20 + textWidth, // end X (start X + text width)
      tempY + 1 // end Y (same as start Y to make it straight)
    );

    tempY += 15;
    doc.setFont(undefined, "bold");
    doc.text(`Pasal 378 KUHP`, 20, tempY);
    tempY += 6;
    doc.text(
      `"Barangsiapa dengan maksud untuk menguntungkan diri sendiri atau orang lain`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `melawan hukum, dengan memakai nama palsu atau martabat palsu, dengan tipu`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `muslihat ataupun rangkaian kebohongan, menggerakkan orang lain untuk`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `barang sesuatu kepadanya, atau supaya memberi hutang maupun menghapuskan piutang`,
      20,
      tempY
    );
    tempY += 6;
    text = `DIANCAM KARENA PENIPUAN DENGAN PIDANA PENJARA PALING LAMA EMPAT TAHUN.`;
    doc.text(text, 20, tempY);
    textWidth = doc.getTextWidth(text);
    doc.line(
      20, // start X
      tempY + 1, // start Y (slightly below text)
      20 + textWidth, // end X (start X + text width)
      tempY + 1 // end Y (same as start Y to make it straight)
    );

    tempY += 15;
    doc.setFont(undefined, "normal");
    doc.text(`Selain itu, perlu Kami informasikan juga bahwa`, 20, tempY);
    doc.setFont(undefined, "bold");
    text = `KEWAJIBAN PENYEWA KEPADA KAMI`;
    doc.text(text, 116, tempY);
    textWidth = doc.getTextWidth(text);
    doc.line(
      116, // start X
      tempY + 1, // start Y (slightly below text)
      116 + textWidth, // end X (start X + text width)
      tempY + 1 // end Y (same as start Y to make it straight)
    );
    tempY += 6;
    text = `ATAS MERUPAKAN UTANG YANG TELAH JATUH TEMPO DAN DAPAT`;
    doc.text(text, 20, tempY);
    textWidth = doc.getTextWidth(text);
    doc.line(
      20, // start X
      tempY + 1, // start Y (slightly below text)
      20 + textWidth, // end X (start X + text width)
      tempY + 1 // end Y (same as start Y to make it straight)
    );
    doc.setFont(undefined, "normal");
    doc.text(`yang`, 165, tempY);
    tempY += 6;
    doc.text(
      `diatur di dalam ketentuan Undang-Undang Nomor 37 Tahun 2004 tentang Kepailitan dan`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(`Penundaan Kewajiban Pembayaran Utang, sehingga`, 20, tempY);
    text = `DAPAT MENGAKIBATKAN`;
    doc.setFont(undefined, "bold");
    doc.text(text, 120, tempY);
    textWidth = doc.getTextWidth(text);
    doc.line(
      120, // start X
      tempY + 1, // start Y (slightly below text)
      120 + textWidth, // end X (start X + text width)
      tempY + 1 // end Y (same as start Y to make it straight)
    );
    tempY += 6;
    text = `KEHILANGAN HAK PENYEWA UNTUK MENGUASAI DAN MENGURUS HARGA KEKAYAAN`;
    doc.text(text, 20, tempY);
    textWidth = doc.getTextWidth(text);
    doc.line(
      20, // start X
      tempY + 1, // start Y (slightly below text)
      20 + textWidth, // end X (start X + text width)
      tempY + 1 // end Y (same as start Y to make it straight)
    );
    tempY += 6;
    text = `PENYEWA KARENA TERJADINYA KEPAILITAN.`;
    doc.text(text, 20, tempY);
    textWidth = doc.getTextWidth(text);
    doc.line(
      20, // start X
      tempY + 1, // start Y (slightly below text)
      20 + textWidth, // end X (start X + text width)
      tempY + 1 // end Y (same as start Y to make it straight)
    );

    doc.setFont(undefined, "normal");
    tempY += 10;
    doc.text(`5.`, 10, tempY);
    doc.text(
      `Dengan tidak diselesaikannya Kewajiban Pembayaran Penyewa kepada Kami, maka bersama`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(`ini Kami memberikan`, 20, tempY);
    doc.setFont(undefined, "bold");
    text = `PERINGATAN (SOMASI)`;
    doc.text(text, 65, tempY);
    textWidth = doc.getTextWidth(text);
    doc.line(
      65, // start X
      tempY + 1, // start Y (slightly below text)
      65 + textWidth, // end X (start X + text width)
      tempY + 1 // end Y (same as start Y to make it straight)
    );
    doc.setFont(undefined, "normal");
    doc.text(`kepada Penyewa untuk melunasi seluruh`, 115, tempY);
    tempY += 6;
    doc.text(`kewajiban pembayaran Penyewa kepada Kami sebesar`, 20, tempY);
    doc.setFont(undefined, "bold");
    doc.text(`Rp. ${jumlahPiutang.toLocaleString("en-US")},-`, 130, tempY);
    tempY += 6;
    doc.text(`( ${angkaTerbilang(jumlahPiutang)} rupiah )`, 20, tempY);

    doc.setFont(undefined, "normal");
    tempY += 10;
    doc.text(
      `secara penuh dan seketika melalui nomor rekening sebagai berikut:`,
      20,
      tempY
    );

    doc.setFont(undefined, "bold");
    tempY += 10;
    doc.text(`Bank`, 55, tempY);
    doc.text(`: ${user.cabang.bankSomasi}`, 100, tempY);
    tempY += 6;
    doc.text(`Cabang`, 55, tempY);
    doc.text(`: ${user.cabang.cabangSomasi}`, 100, tempY);
    tempY += 6;
    doc.text(`Nomor Rekening`, 55, tempY);
    doc.text(`: ${user.cabang.noRekeningSomasi}`, 100, tempY);
    tempY += 6;
    doc.text(`Atas Nama`, 55, tempY);
    doc.text(`: ${user.cabang.atasNamaSomasi}`, 100, tempY);

    doc.addPage();

    // Add image to PDF
    doc.addImage(imgData, "JPEG", 140, 10, 50, 20);

    doc.setFont(undefined, "normal");
    tempY = 30;
    tempY += 6;
    doc.text(
      `Kewajiban tersebut di atas wajib dilaksanakan oleh Penyewa`,
      20,
      tempY
    );
    doc.setFont(undefined, "bold");
    text = `SELAMBAT-LAMBATNYA`;
    doc.text(text, 135, tempY);
    textWidth = doc.getTextWidth(text);
    doc.line(
      135, // start X
      tempY + 1, // start Y (slightly below text)
      135 + textWidth, // end X (start X + text width)
      tempY + 1 // end Y (same as start Y to make it straight)
    );
    // tempTglSuratSomasi
    tempY += 6;
    text = `HARI ${getDayNameIndo(
      tglSuratSomasiAkhirDate
    )} TANGGAL ${formatDate(tglSuratSomasiAkhirDate)}.`;
    doc.text(text, 20, tempY);
    textWidth = doc.getTextWidth(text);
    doc.line(
      20, // start X
      tempY + 1, // start Y (slightly below text)
      20 + textWidth, // end X (start X + text width)
      tempY + 1 // end Y (same as start Y to make it straight)
    );

    tempY += 15;
    doc.setFont(undefined, "normal");
    doc.text(
      `Penyewa juga wajib memberitahukan kepada Kami apabila Penyewa telah melakukan`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `pembayaran kepada Nomor Rekening tersebut di atas. Semua pembayaran di luar`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `rekening tersebut di atas adalah merupakan pembayaran yang tidak sah.`,
      20,
      tempY
    );

    tempY += 10;
    doc.text(`6.`, 10, tempY);
    doc.text(
      `Apabila Penyewa tidak juga melaksanakan kewajiban pembayaran dalam jangka waktu`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `yang disebutkan dalam Butir 5 di atas, maka Kami akan melakukan tindakan - tindakan`,
      20,
      tempY
    );
    tempY += 6;
    doc.text(
      `tegas apapun yang dianggap perlu, baik dengan mengajukan`,
      20,
      tempY
    );
    doc.setFont(undefined, "bold");
    text = `PELAPORAN PIDANA ATAS`;
    doc.text(text, 138, tempY);
    textWidth = doc.getTextWidth(text);
    doc.line(
      138, // start X
      tempY + 1, // start Y (slightly below text)
      138 + textWidth, // end X (start X + text width)
      tempY + 1 // end Y (same as start Y to make it straight)
    );
    tempY += 6;
    text = `DUGAAN TINDAK PIDANA PENIPUAN, GUGATAN PERDATA, MAUPUN PERMOHONAN`;
    doc.text(text, 20, tempY);
    textWidth = doc.getTextWidth(text);
    doc.line(
      20, // start X
      tempY + 1, // start Y (slightly below text)
      20 + textWidth, // end X (start X + text width)
      tempY + 1 // end Y (same as start Y to make it straight)
    );
    tempY += 6;
    text = `KEPAILITAN TERHADAP PENYEWA.`;
    doc.text(text, 20, tempY);
    textWidth = doc.getTextWidth(text);
    doc.line(
      20, // start X
      tempY + 1, // start Y (slightly below text)
      20 + textWidth, // end X (start X + text width)
      tempY + 1 // end Y (same as start Y to make it straight)
    );

    doc.setFont(undefined, "normal");
    tempY += 20;
    doc.text(`Hormat Kami,`, 40, tempY);

    doc.setFont(undefined, "bold");
    tempY += 30;
    doc.text(`SJM`, 48, tempY);
    tempY += 6;
    doc.text(`( NO. TELP : ${addSpaceEvery4(tlpRegister)} )`, 25, tempY);

    window.open(URL.createObjectURL(doc.output("blob")));
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Box>
      <ScrollToTop />
      <Typography color="#757575">Piutang</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Surat Somasi
      </Typography>
      {isSuratSomasisExist && (
        <Box sx={downloadButtons}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={() => downloadPdf()}>
              CETAK
            </Button>
          </ButtonGroup>
        </Box>
      )}
      <Box sx={buttonModifierContainer}>
        {user.tipeUser !== "OWN/DIREKSI" && (
          <ButtonModifier
            id={id}
            kode={isSuratSomasisExist}
            addLink={`/suratSomasi/tambahSuratSomasi`}
            editLink={null}
            deleteUser={deleteSuratSomasi}
            nameUser={noJual}
          />
        )}
      </Box>
      {user.tipeUser !== "EKS" && user.tipeUser !== "OWN/DIREKSI" && (
        <>
          <hr />
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Kode Eksekutor :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={kolektorOptions}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        placeholder="SEMUA EKSEKUTOR"
                        {...params}
                      />
                    )}
                    onInputChange={(e, value) => filterKolektor(value)}
                    inputValue={kodeKolektorInput}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
        </>
      )}
      <hr />
      {isSuratSomasisExist && (
        <>
          <Box sx={showDataContainer}>
            <Box sx={showDataWrapper}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      No. Jual :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={noJual} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      No. Surat Somasi :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={noSuratSomasi} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Tgl. Surat Somasi :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={tglSuratSomasi} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Eksekutor :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={kodeKolektor} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
            <Box sx={[showDataWrapper, secondWrapper]}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Surat Somasi Ke :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={suratSomasiKe} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Telepon :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={tlpRegister} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Jumlah. Piutang :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={jumlahPiutang.toLocaleString("en-US")}
                        disabled
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Jumlah. Bayar :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={jumlahBayar.toLocaleString("en-US")}
                        disabled
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
          </Box>
          <Divider sx={dividerStyle} />
        </>
      )}
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableSuratSomasi
          currentPosts={suratSomasisData}
          tipeUser={user.tipeUser}
        />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Box>
  );
};

export default TampilSuratSomasi;

const subTitleText = {
  fontWeight: "900",
};

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const dividerStyle = {
  pt: 4,
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const spacingTop = {
  mt: 4,
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};
